import { createEmitter } from 'utils/emitter';

// Notifies components that cache AMBOSS data in memory (e.g. the history
// hook) when a user change wipes it, so their state clears with the storage.
const resetEmitter = createEmitter();

export const onAmbossDataReset = resetEmitter.subscribe;
export const triggerAmbossDataReset = resetEmitter.notify;
